module.exports = __webpack_public_path__ + "static/media/image_7.5428443a.png";